{
  "alert": "Varsel",
  "dismiss": "Lukk"
}